import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '@app/core/services/data.service';
import { SubSink } from '@app/core/subsink';
import { ITooltipOptions } from '@app/shared/components/interfaces/tooltip-options.interface';

import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Component({
    selector: 'app-rtls-tool-bar',
    templateUrl: './rtls-tool-bar.component.html',
    styleUrls: ['./rtls-tool-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RtlsToolBarComponent implements OnInit, OnDestroy {

    @ViewChild('searchBar', { static: true }) searchBar: any;

    @Input() public tooltipOptions: ITooltipOptions = {
        show: false,
        text: '',
        position: 'below',
    };

    @Input() public title: string;
    @Input() public subTitle: string = '';
    @Input() public moduleTitle: string = '';
    @Input() public subTitleIcon: string;
    @Input() public showTitle: boolean = true;
    @Input() public isRequesting: boolean = false;

    @Input() public showRefreshButton = true;

    @Input() public showDisplayType = true;
    @Input() public showAddButton = true;
    @Input() public showQuickCreateButton = false;
    @Input() public showExportButton = false;
    @Input() public showFilterButton = false;
    @Input() public showReportFilter = false;
    @Input() public showActionButton = false;
    @Input() public showEditButton = false;
    @Input() public showSearchPanel = true;
    @Input() public searchTerm = '';

    @Output() isAddButtonClicked = new EventEmitter();
    @Output() isQuickCreateButtonClicked = new EventEmitter();
    @Output() isEditButtonClicked = new EventEmitter();
    @Output() isActionButtonClicked = new EventEmitter();
    @Output() isShowTableViewType = new EventEmitter();
    @Output() isLoadDataClick = new EventEmitter();
    @Output() isShowTableExport = new EventEmitter();

    @Output() isFilterButtonClick = new EventEmitter(true);
    @Output() isReportFilterButtonClick = new EventEmitter(true);

    public filterDataSource: any;
    public listCardState = true;
    public itemCount: number = 0;

    private subs = new SubSink();
    constructor(private dataService: DataService) { }

    ngOnInit(): void {
        this.subs.sink = fromEvent(this.searchBar.nativeElement, 'keyup')
            .pipe(
                filter(Boolean), //value => this.searchBar.nativeElement.value.length > 2
                debounceTime(500),
                distinctUntilChanged(),
                tap(() => {
                    this.searchTerm = this.searchBar.nativeElement.value;
                    this.applyFilter(this.searchBar.nativeElement.value);
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    getIcon(): any{
        return JSON.parse(this.subTitleIcon.replace(/'/g, '"'));
    }

    public applyFilter(searchText: string): void {
        const terms: string = searchText.trim();
        this.dataService.globalSearchTerms.next(terms === '' ? null : terms.trim());
    }

    public pageChanged($event: any): void { }

    public newData(id: any): void { }


    public showTableViewTypeClick(): void {
        this.listCardState = !this.listCardState;
        this.isShowTableViewType.emit(this.listCardState ? 'LIST' : 'CARD');
    }

    public loadDataClick(): void {
        this.isLoadDataClick.emit();
    }

    public showTableExportClick(): void {
        this.isShowTableExport.emit();
    }

    public showFilterClick(): void {
        this.isFilterButtonClick.emit();
    }

    public showReportFilterClick(): void {
        this.isReportFilterButtonClick.emit();
    }

    public addButtonClick(): void {
        this.isAddButtonClicked.emit();
    }

    public quickCreateButtonClick(): void {
        this.isQuickCreateButtonClicked.emit();
    }

    public editButtonClick(): void {
        this.isEditButtonClicked.emit();
    }

    public actionButtonClick(): void {
        this.isActionButtonClicked.emit();
    }

    public setItemObjectTypeId(item: any): void {

        this.dataService._objectItemTypeId.next(item);
    }

}
